import { AsyncPipe, CurrencyPipe, NgOptimizedImage } from '@angular/common';
import { Component, inject, OnInit, ViewEncapsulation } from '@angular/core';
import { CardComponent } from '@components/card/card.component';
import { PaymentCardFormComponent } from '@components/consultation-request/payment-card-form/payment-card-form.component';
import { PaymentSubmitButtonComponent } from '@components/consultation-request/payment-submit-button/payment-submit-button.component';
import { OrderFlowUpsellComponent } from '@components/order-flow-upsell/order-flow-upsell.component';
import { EdTreatmentUpsell } from '@data/tests';
import { EdTreatmentResponse } from '@models/ed-treatment-response';
import { OrderUpsell } from '@models/order-upsell';
import { UpsellFaq } from '@models/upsell-faq';
import { ImageFallback } from '@pipes/image-fallback';
import { EdTreatmentService } from '@services/ed-treatment.service';
import { provideDefaultPaymentConfig } from '@services/payment.service';

@Component({
  selector: 'app-ed-treatment',
  imports: [
    AsyncPipe,
    CurrencyPipe,
    NgOptimizedImage,
    CardComponent,
    ImageFallback,
    PaymentCardFormComponent,
    PaymentSubmitButtonComponent,
  ],
  templateUrl: './ed-treatment.component.html',
  styleUrl: './ed-treatment.component.scss',
  providers: [provideDefaultPaymentConfig()],
  encapsulation: ViewEncapsulation.None,
})
export class EdTreatmentComponent extends OrderFlowUpsellComponent implements OnInit {
  public override readonly upsellTest: OrderUpsell = EdTreatmentUpsell;
  public readonly upsellTestLineItem: OrderUpsell = { ...EdTreatmentUpsell, name: 'ED Treatment' };
  public edTreatmentResponse!: EdTreatmentResponse;
  public isExpandedContent: boolean = false;

  private readonly edTreatmentService = inject(EdTreatmentService);

  /**
   * Initializes the component by fetching the ED treatment content.
   */
  public ngOnInit(): void {
    this.getContent();
  }

  /**
   * Toggles the expanded state of the read more/less content section.
   */
  public toggleContent(): void {
    this.isExpandedContent = !this.isExpandedContent;
  }

  /**
   * Toggles the expanded state of the given FAQ item.
   *
   * @param {UpsellFaq} faq the FAQ item to toggle
   */
  public toggleFaqItem(faq: UpsellFaq): void {
    faq.isExpanded = !faq.isExpanded;
  }

  /** {@inheritDoc OrderFlowUpsellComponent.onUpsellSuccess} */
  protected override onUpsellSuccess(): void {
    this.processing = false;
    this.navigateToNextPage();
  }

  /**
   * Fetches the ED treatment upsell content from the API.
   */
  private getContent(): void {
    this.loadingService.toggleLoader(true);
    this.edTreatmentService.getContent().subscribe({
      next: (response) => {
        this.edTreatmentResponse = response;
        this.loadingService.toggleLoader(false);
      },
      error: () => {
        this.loadingService.toggleLoader(false);
        setTimeout(() => this.navigateToNextPage(), 0);
      },
    });
  }
}
